// extracted by mini-css-extract-plugin
export default {"UrlLink":"UrlLink_UrlLink__Ty8jf","Infotext":"UrlLink_Infotext__5bp2-"};